import React from 'react'
import './Mark.scss'

const Mark = () => (<div className="marknf" />)

export default Mark;
